import { render, staticRenderFns } from "./_Pickup.vue?vue&type=template&id=69e8f4bf&scoped=true&"
import script from "./_Pickup.vue?vue&type=script&lang=js&"
export * from "./_Pickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e8f4bf",
  null
  
)

export default component.exports